import React from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';

import HomepageAnimatedBanner from '../Components/CustomComponents/HomepageAnimatedBanner';
import SocialIconsComponent from '../Components/CustomComponents/SocialIconsComponent';

function PrivacyPolicy() {
    return (

        <div className="home-wrapper">

            <Helmet>
                <meta
                    name="description"
                    content="VCASSO LLC Privacy Policy Page." />
                <link rel="canonical" href={window.location.href} />
                <title>VCASSO LLC | Privacy Policy</title>
            </Helmet>

                <HomepageAnimatedBanner/>

            <div className="container">

                <div className="privacy-policy">

                    <h1>Privacy Policy</h1>

                    <p><strong>Effective Date:</strong> May 16, 2026</p>

                    <p>
                        This Privacy Policy describes how VCASSO LLC collects,
                        uses, and protects information provided through our wildfire weather
                        alert notification system.
                    </p>

                    <h2>Information We Collect</h2>

                    <p>We may maintain mobile phone numbers for authorized operational personnel receiving wildfire weather alert notifications.</p>

                    <h2>How We Use Information</h2>

                    <p>Information is used solely for:</p>

                    <ul>
                        <li>Delivering Red Flag Warning notifications</li>
                        <li>Sending wildfire weather alert updates</li>
                        <li>Operational safety communications</li>
                        <li>Managing SMS notification preferences</li>
                    </ul>

                    <p>
                        We do not sell, rent, or share mobile phone numbers or personal
                        information with third parties for marketing purposes.
                    </p>

                    <h2>SMS Communications</h2>

                    <p>
                        By voluntarily providing a mobile phone number, users consent to
                        receive automated SMS notifications regarding wildfire weather
                        conditions, Red Flag Warnings, warning updates, and warning
                        cancellations.
                    </p>

                    <p>
                        Message frequency may vary depending on weather activity and
                        operational conditions.
                    </p>
                    <p>
                        SMS consent is not shared with third parties or affiliates for marketing purposes.
                    </p>

                    <p>Users may reply:</p>

                    <ul>
                        <li>STOP to unsubscribe</li>
                        <li>HELP for assistance</li>
                    </ul>

                    <p>Standard message and data rates may apply.</p>

                    <h2>Data Security</h2>

                    <p>
                        We take reasonable measures to protect submitted information from unauthorized access, disclosure, or misuse.
                    </p>

                    <h2>Third-Party Service Providers</h2>

                    <p>
                        SMS notifications may be delivered through third-party communication providers including <a href="https://www.twilio.com" target="_blank" rel="noopener noreferrer">Twilio</a>.
                    </p>

                    <h2>Contact Information</h2>

                    <p>
                        For questions regarding this Privacy Policy or SMS communications,
                        contact:
                    </p>

                    <p>
                        VCASSO LLC.
                        <br />
                        <a title="Email VCASSO LLC." href="mailto:vanja@vcasso.com?subject=Privacy Policy Inquiry">vanja@vcasso.com</a>
                    </p>

                </div>

            

            <SocialIconsComponent />

            </div>

        </div>

    );
}

export default PrivacyPolicy;